import { Button, Spin } from "antd";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Filter } from 'lucide-react';

import { FunnelChart } from "react-funnel-pipeline";
import "react-funnel-pipeline/dist/index.css";
import { useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import Header from "../../components/header";
import {
  fetchDashboardAllActivityCount,
  fetchDashboardCallLeaderBoard,
  fetchDashboardContentInfo,
  fetchDashboardFunnelChart,
  fetchDashboardGraphData,
  fetchDashboardLeadCount,
  fetchDashboardLeadLableGraphData,
  fetchDashboardLeadSourceGraphData,
  fetchDashboardMapcheckIn,
  fetchDashboardQuotationStatusChart,
  fetchDashboardSalesCount,
  fetchDashboardTaskStatusChart,
} from "../../services/dashboardService";
import DashboardAreaChart from "./DashboardAreaChart";
import DashboardHeader from "./DashboardHeader";
import DashboardPieChart, { PieChartData } from "./DashboardPieChart";
import DashboardTabs from "./DashboardTabs";
import { Tabs } from "./dashboard.types";


import DashboardTaskStatusPieChart from "./DashboardTaskStatusPieChart";

import DashboardCallLeaderBoard, {
  TableData,
} from "./DashboardCallLeaderBoard";
import { getDateRange, getDaysDifference } from "../../components/MomentFun";
import { Divider } from "rsuite";
import styled from "styled-components";
import ColumnChart from "./ColumnChart";
import SalesFunnel from "./SalesFunnel";
import LeadsBySourceWithTable from "./LeadsBySourceWithTable";
import logger, { Logger } from '../../utils/logger';

// 🚀 REPORT COMPONENTS NOW LAZY LOADED IN ReportTabsManager - No imports needed here!
import DashboardCallLogsTable from "./DashboardCallLogsTable";
import SalesTargetTracking from "./SalesTargetTracking";
import DashboardLeadAssignmentTable from "./DashboardLeadAssignmentTable";
import DashboardActivityList from "./DashboardActivityList";
import DashboardUserSyncStatus from "./DashboardUserSyncStatus";
import DashboardUserPerformanceReport from "./DashboardUserPerformanceReport";
import DashboardCustomFieldChart from "./DashboardCustomFieldChart";
import DashboardVisibilitySettings from "./DashboardVisibilitySettings";
import { useDashboardVisibility } from "./hooks/useDashboardVisibility";
import ReportTabsManager from "./ReportTabsManager";
import ReportSelectorPopup from "./ReportSelectorPopup";


interface TabItem {
  key: string;
  label: string;
  icon: string;
}



function getTimeFormat(time: any) {
  // const time = Number(newTime.splice(0,4))
  if (time && typeof time === "number") {
    if (!isNaN(time) && isFinite(time)) {
      var date = new Date(0);
      date.setUTCSeconds(time);

      var timeString = date.toISOString().substr(11, 8);
      return timeString;
    } else {
      console.error("Invalid time value:", time);
      return null; // or return an error string, depending on your use case
    }
  } else {
    return;
  }
}


export interface ICount {
  leadAssignedCount: number;
  leadCreateCount: number;
  totalLead: number;
}
export interface DateRange {
  from: string;
  to: string;
}

const StyledDivider = styled(Divider)`
  height: 3rem;
  border-left: 1px solid #d9d9d9;
`;

const Dashboard: React.FC = () => {
  const renderCount = React.useRef(0);
  renderCount.current++;
  if (renderCount.current > 3) {
    console.warn(`⚠️ Dashboard RENDER #${renderCount.current} - Too many re-renders!`);
  }

  const StoreData = useSelector((state: any) => {
    return state?.rootReducers;
  });


  const [filterFromDate, setFilterFromDate] = useState(7);
  const [fromDate, setFromDate] = useState("7d");

  // 🎯 USE DASHBOARD MANAGER for initial date range
  const dateManager = React.useMemo(() => {
    const mgr = require('./dashboardManager').DashboardDateManager.getInstance();
    return mgr;
  }, []);

  const initialRange = React.useMemo(() => dateManager.calculateDateRange('7d'), [dateManager]);

  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>({
    from: initialRange.from,
    to: initialRange.to,
  });
  const [customFromDate, setCustomFromDate] = useState("");
  const [customToDate, setCustomToDate] = useState("");
  const [leadTotals, setLeadTotals] = useState<any>({
    leadAssignedCount: 0,
    leadCreateCount: 0,
    totalLead: 0,
  });
  const [totalActivityCount, setTotalActivityCount] = useState<number>(0);
  const [totalCallCount, setTotalCallCount] = useState<number>(0);
  const [totalSalesCount, setTotalSalesCount] = useState<number>(0);
  const [activityTypes, setActivityTypes] = useState<any>([]);
  const [callingData, setCallingData] = useState<any>([]);
  const [callingDetails, setCallingDetails] = useState<any>({});
  const [leadSourceGraphX, setLeadSourceGraphX] = useState<any>([]);
  const [leadSourceGraphS, setLeadSourceGraphS] = useState<any>([]);
  const [saleFunnelGraphS, setSaleFunnelGraphS] = useState<any>([]);
  const [funnelColor, setFunnelColor] = useState<any>([]);
  const [mapCheckInData, setMapCheckInData] = useState<any>([]);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [selectedListIds, setSelectedListIds] = useState<string[]>([]); // ✅ ACTIVATED: List filtering
  const [isOrganization, setIsOrganization] = useState<boolean>(false);
  const [isPageLoad, setIsPageLoad] = useState<boolean>(false);
  const [loadingStates, setLoadingStates] = useState<{
    core: boolean;
    charts: boolean;
    tabData: boolean;
  }>({
    core: false,
    charts: false,
    tabData: false,
  });
  const [leadBySource, setLeadBySource] = useState<PieChartData[]>([]);
  const [taskByStatus, setTaskByStatus] = useState<PieChartData[]>([]);
  const [quotationByStatus, setQuotationByStatus] = useState<PieChartData[]>(
    []
  );
  // ❌ REMOVED: const [callLogsDrawerOpen, setCallLogsDrawerOpen] - no longer needed
  const [visibilitySettingsOpen, setVisibilitySettingsOpen] = useState(false);
  // ❌ REMOVED: const [reportsTabsOpen, setReportsTabsOpen] - ReportTabsManager always visible now
  const [reportSelectorOpen, setReportSelectorOpen] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState<string | undefined>();
  const [selectedReportTitle, setSelectedReportTitle] = useState<string | undefined>();
  
  // Initialize visibility configuration
  const {
    visibilityConfig,
    isLoading: visibilityLoading,
    saveConfig,
    shouldRenderComponent,
    getEnabledCount,
    getTotalCount,
  } = useDashboardVisibility();

  const [leadByLabel, setLeadByLabel] = useState<PieChartData[]>([]);
  const [callLeaderBoard, setCallLeaderBoard] = useState<TableData[]>([]);
  const [tabName, setTabName] = useState<Tabs>("lead");
  const [taskPerc, setTaskPec] = useState<any>("");
  const [contentCountInfo, setContentCountInfo] = useState<any>({
    share: 0,
    view: 0,
  });

  // Simple cache to avoid refetching unchanged data
  const [dataCache, setDataCache] = useState<any>({});
  const [lastFetchKey, setLastFetchKey] = useState<string>('');

  const [taskCount, setTaskCount] = useState([]);

  // Calculate current fromDate and toDate based on filters
  const currentFromDate = isCustomDate
    ? customFromDate
    : selectedDateRange.from;
  const currentToDate = isCustomDate
    ? customToDate
    : selectedDateRange.to;

  // 🚀 NEW: Simplified data loading - only for top cards + secondary metrics
  // Individual reports fetch their own data when opened
  const loadDataForCurrentTab = async (specificTab?: string) => {
    try {
      const currentTab = specificTab || tabName;

      // Create cache key based on current filters
      const cacheKey = `${currentTab}-${currentFromDate}-${currentToDate}-${selectedUserId}-${selectedTeamId}-${isOrganization}`;

      // Check if we have recent data for the same parameters
      if (lastFetchKey === cacheKey && Date.now() - (dataCache.timestamp || 0) < 30000) {
        Logger.log('📦 Using cached dashboard data');
        return;
      }

      Logger.log('🔄 Loading dashboard data (top cards + secondary metrics)');

      // Set loading state
      setLoadingStates({ core: true, charts: false, tabData: false });

      // 📊 ALWAYS load these APIs for:
      // 1. Top 5 cards (Leads, Calls, Activity, Sales counts)
      // 2. Secondary metrics (Contacted%, Conversion%, Task%, Views, Shares)

      const coreDataPromises = [];

      // ✅ Lead data (for Leads count + Contacted% + Conversion%)
      coreDataPromises.push(DashboardLeadCount());

      // ✅ Activity data (for Calls count + Activity count + Task%)
      coreDataPromises.push(DashboardAllActivityData());

      // ✅ Sales data (for Sales total)
      coreDataPromises.push(DashboardSalesData());

      // ✅ Content data (for Views + Shares) - only if secondary metrics visible
      if (shouldRenderComponent('metrics', 'secondaryMetrics')) {
        coreDataPromises.push(getContentCount());
      }

      Logger.log(`📊 Loading ${coreDataPromises.length} core APIs for dashboard cards`);

      // Load all core data in parallel
      await Promise.all(coreDataPromises);
      setLoadingStates({ core: false, charts: false, tabData: false });

      // Update cache
      setDataCache({ timestamp: Date.now() });
      setLastFetchKey(cacheKey);

      Logger.log('✅ Dashboard cards data loaded successfully');
      Logger.log('📑 Individual reports will fetch their own data when opened');
    } catch (error) {
      Logger.log('❌ Error loading dashboard data:', error);
      setLoadingStates({ core: false, charts: false, tabData: false });
      throw error;
    }
  };

  useEffect(() => {
    Logger.log('5. selectedDateRange effect triggered with:', {
      selectedDateRange,
      isCustomDate,
      filterFromDate,
      visibilityLoading
    });
    if (!isCustomDate && selectedDateRange.from && selectedDateRange.to && !visibilityLoading) {
      Logger.log('6. Conditions met (including visibility loaded), calling APIs');
      loadDataForCurrentTab();
    } else if (visibilityLoading) {
      Logger.log('⏳ Waiting for visibility configuration to load...');
    }
  }, [selectedDateRange, isCustomDate, visibilityLoading]);
  

  useEffect(() => {
    if (customFromDate && customToDate && !visibilityLoading) {
      loadDataForCurrentTab();
      setSelectedDateRange({ from: customFromDate, to: customToDate });
    }
  }, [customFromDate, customToDate, visibilityLoading]);

  useEffect(() => {
    if (selectedUserId && !visibilityLoading) {
      loadDataForCurrentTab();
    }
  }, [selectedUserId, visibilityLoading]);

  useEffect(() => {
    if (selectedTeamId && !visibilityLoading) {
      loadDataForCurrentTab();
    }
  }, [selectedTeamId, visibilityLoading]);

  useEffect(() => {
    if (isOrganization && !visibilityLoading) {
      loadDataForCurrentTab();
    }
  }, [isOrganization, visibilityLoading]);

  // 🚧 COMMENTED OUT: Handle list selection changes - Feature under development
  /*
  useEffect(() => {
    if (selectedListIds.length >= 0) { // Trigger even when clearing selection
      Logger.log('📋 Dashboard: List selection changed, reloading data:', selectedListIds);
      loadDataForCurrentTab();
    }
  }, [selectedListIds]);
  */

  const getContentCount = async () => {
    try {
      let fromDate = isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const { data } = await fetchDashboardContentInfo(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId
      );
      if (data?.data) {
        let share =
          data?.data?.contentTypeCount?.find((e: any) => e.type === "shared")
            ?.count || 0;

        let view =
          data?.data?.contentTypeCount?.find((e: any) => e.type === "view")
            ?.count || 0;

        setContentCountInfo({
          share,
          view,
        });
      }
    } catch (error) {}
  };

  const DashboardLeadCount = async () => {
    Logger.log('7. DashboardLeadCount called with:', {
      isCustomDate,
      customFromDate,
      customToDate,
      selectedDateRange
    });
  
    try {
      setIsPageLoad(true);
      let fromDate = isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = isCustomDate
        ? customToDate
        : selectedDateRange.to;
  
      Logger.log('8. Making API call with dates:', { fromDate, toDate });
  
      const response = await fetchDashboardLeadCount(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId,
        selectedListIds.length > 0 ? selectedListIds.join(',') : undefined // ✅ List filtering with listIds
      );
      
      Logger.log('9. API Response:', response);
  
      if (response && response.status) {
        setLeadTotals(response.data.data?.count);
        setIsPageLoad(false);
      }
    } catch (err) {
      console.error('9. API Error:', err);
      setIsPageLoad(false);
    }
  };
  

  
  const DashboardAllActivityData = async () => {
    try {
      setIsPageLoad(true);
      let fromDate = isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardAllActivityCount(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId,
        selectedListIds.length > 0 ? selectedListIds.join(',') : undefined // ✅ List filtering with listIds
      );
      if (response && response.status) {
        let resposneData = response.data.data;
        let tempCallingData = resposneData?.callingCount;
        let callCount = 0;
        tempCallingData.forEach((item: any) => {
          callCount += item.count;
        });
        setTotalCallCount(callCount);
        setTotalActivityCount(resposneData?.totalActivity);
        setActivityTypes(resposneData?.activityTypes);
        setCallingData(resposneData?.callingCount);
        setCallingDetails(resposneData?.callingDetails);
        setIsPageLoad(false);
      }
    } catch (err) {
      Logger.log(err);
      setIsPageLoad(false);
    }
  };

  const DashboardSalesData = async () => {
    try {
      setIsPageLoad(true);
      let fromDate = isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardSalesCount(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId,
        selectedListIds.length > 0 ? selectedListIds.join(',') : undefined // ✅ List filtering with listIds
      );
      if (response && response.status) {
        let resposneData = response.data.data;
        setTotalSalesCount(resposneData?.salesValue || 0);
        setIsPageLoad(false);
      }
    } catch (err) {
      Logger.log(err);
      setIsPageLoad(false);
    }
  };

  const DashboardGraph = async (tab: string) => {
    try {
      setIsPageLoad(true);
      let fromDate = isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardGraphData(
        fromDate,
        toDate,
        tab,
        isOrganization,
        selectedUserId,
        selectedTeamId
      );
      if (response && response.status) {
        let resposneData = response.data.data;
        if (resposneData.length > 0) {
          let tempXData = [];
          let tempSData = [];
          for (let i = 0; i < resposneData.length; i++) {
            tempXData.push(resposneData[i].count);
            tempSData.push(moment(resposneData[i].point).format("YYYY-MM-DD"));
          }
          setIsPageLoad(false);
        } else {
          setIsPageLoad(false);
        }
      }
    } catch (err) {
      setIsPageLoad(false);
      Logger.log(err);
    }
  };
const handleDashboardRefresh = async () => {
  logger.log('🔄 Dashboard refresh triggered');
  
  try {
    // Clear cache to force fresh data
    setDataCache({});
    setLastFetchKey('');
    
    // Use the existing loadDataForCurrentTab function which already handles all the logic
    await loadDataForCurrentTab();
    logger.log('✅ Dashboard refresh completed successfully');
  } catch (error) {
    console.error('❌ Dashboard refresh failed:', error);
    throw error; // Re-throw so the button can show error state
  }
};

// Optimized tab switching - only load tab-specific data
const handleTabChange = async (newTab: Tabs) => {
  setTabName(newTab);
  
  // Only load tab-specific graph data for immediate feedback if area chart is visible
  if (shouldRenderComponent('charts', 'areaChart')) {
    try {
      await DashboardGraph(newTab);
      Logger.log('✅ Tab data loaded for:', newTab);
    } catch (error) {
      Logger.log('❌ Error loading tab data:', error);
    }
  } else {
    Logger.log('⏭️ Skipped tab data loading - area chart is hidden');
  }
};
  const DashboardLeadLabelGraph = async (date?: any) => {
    try {
      setIsPageLoad(true);
      let fromDate = date?.from
        ? date.from
        : isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = date?.to
        ? date.to
        : isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardLeadLableGraphData(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId,
        selectedListIds.length > 0 ? selectedListIds.join(',') : undefined // ✅ List filtering with listIds
      );
      if (response && response.status) {
        let resposneData = response.data.data;
        if (resposneData.length > 0) {
          let tempXData = [];
          let tempSData = [];
          let color = [];
          let tempColorData = StoreData.user.userPreferences.labels;
          for (let j = 0; j < tempColorData.length; j++) {
            color.push(tempColorData[j].color);
          }
          for (let i = 0; i < resposneData.length; i++) {
            tempXData.push(resposneData[i].count);
            tempSData.push(resposneData[i].type);
          }
          setLeadByLabel(
            resposneData.map((r: any) => ({
              label: r.displayName,
              value: r.count,
            }))
          );
          setTimeout(() => {
            setIsPageLoad(false);
          }, 1000);
        } else {
          setIsPageLoad(false);
        }
      }
    } catch (err) {
      Logger.log(err);
      setIsPageLoad(false);
    }
  };

  const DashboardLeadSourceGraph = async (date?: any) => {
    try {
      setIsPageLoad(true);
      let fromDate = date?.from
        ? date.from
        : isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = date?.to
        ? date.to
        : isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardLeadSourceGraphData(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId,
        selectedListIds.length > 0 ? selectedListIds.join(',') : undefined // ✅ List filtering with listIds
      );
      if (response && response.status) {
        let resposneData = response.data.data;
  
        if (resposneData.length > 0) {
          // Sort and transform the data before setting leadBySource
          setLeadBySource(
            resposneData
              .sort((a: { count: number }, b: { count: number }) => b.count - a.count)
              .map((d: any) => ({
                label: d.integration || "unknown",
                value: d.count,
                rate: d.convertedRate,
              }))
          );
          let tempXData = [];
          let tempSData = [];
          for (let i = 0; i < resposneData.length; i++) {
            if (resposneData[i].integration) {
              tempXData.push(resposneData[i].count);
              tempSData.push(resposneData[i].integration);
            }
          }
          setLeadSourceGraphX(tempXData);
          setLeadSourceGraphS(tempSData);
          setTimeout(() => {
            setIsPageLoad(false);
          }, 1000);
        } else {
          setLeadSourceGraphX([]);
          setLeadSourceGraphS([]);
          setIsPageLoad(false);
        }
      }
    } catch (err) {
      Logger.log(err);
      setIsPageLoad(false);
    }
  };

  const DashboardSaleFunnelGraph = async (date?: any) => {
    try {
      setIsPageLoad(true);
      let fromDate = date?.from
        ? date.from
        : isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = date?.to
        ? date.to
        : isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardFunnelChart(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId,
        selectedListIds.length > 0 ? selectedListIds.join(',') : undefined // ✅ List filtering with listIds
      );
      if (response && response.status) {
        let resposneData = response.data.data;

        if (resposneData.length > 0) {
          let tempFunnelData = [];
          let tempFunnelColor = [];
          let tempColors = StoreData.user.userPreferences.status;
          for (let i = 0; i < resposneData.length; i++) {
            let X_label = _.capitalize(
              resposneData[i].type?.split("_")?.join(" ")
            );
            let X = `${resposneData[i].count} ${X_label}`;
            let tempObj = {
              name: X,
              value: resposneData[i].saleValue,
            };
            tempFunnelData.push(tempObj);
            for (let j = 0; j < tempColors.length; j++) {
              if (resposneData[i].type === tempColors[j].value) {
                tempFunnelColor.push(tempColors[j].color);
              }
            }
          }
          
          setSaleFunnelGraphS(tempFunnelData);
          setFunnelColor(tempFunnelColor);
          setTimeout(() => {
            setIsPageLoad(false);
          }, 1000);
        } else {
          setSaleFunnelGraphS([]);
          setIsPageLoad(false);
        }
      }
    } catch (err) {
      Logger.log(err);
      setIsPageLoad(false);
    }
  };

  const DashboardTaskStatusGraph = async (date?: any) => {
    try {
      setIsPageLoad(true);
      let fromDate = date?.from
        ? date.from
        : isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = date?.to
        ? date.to
        : isCustomDate
        ? customToDate
        : selectedDateRange.to;

      const response = await fetchDashboardTaskStatusChart(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId
      );
      if (response && response.status) {
        let resposneData = response.data.data;
        let data = [];
        setTaskPec(resposneData?.percentage);

        setTaskCount(resposneData?.taskTypeCounts);

        for (const element of Object.keys(resposneData.taskCounts)) {
          data.push({
            label: element,
            value: resposneData.taskCounts[element],
          });
        }
        setTaskByStatus(data);
        setTimeout(() => {
          setIsPageLoad(false);
        }, 1000);
      }
    } catch (err) {
      Logger.log(err);
      setIsPageLoad(false);
    }
  };

  function addTotalForIncomingAndOutgoing(data: any) {
    let total = 0;
    data.forEach((type: any) => {
      // Add to total if the type is INCOMING or OUTGOING
      if (type.type === "INCOMING" || type.type === "OUTGOING") {
        total += type.count;
      }
    });

    return total;
  }

  const DashboardCallLeaderBoardFun = async (date?: any) => {
    try {
      setIsPageLoad(true);
      let fromDate = date?.from
        ? date.from
        : isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = date?.to
        ? date.to
        : isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardCallLeaderBoard(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId
      );
      if (response && response.status) {
        let resposneData: any = response?.data?.data ?? [];

        let tempRes = resposneData
          .map((e: any) => ({
            ...e,
            total: addTotalForIncomingAndOutgoing(e.types),
          }))
          ?.sort((a: any, b: any) => b.total - a.total);

        setCallLeaderBoard(tempRes);

        setTimeout(() => {
          setIsPageLoad(false);
        }, 1000);
      }
    } catch (err) {
      Logger.log(err);
      setIsPageLoad(false);
    }
  };

  const DashboardQuotationStatusGraph = async (date?: any) => {
    try {
      setIsPageLoad(true);
      let fromDate = date?.from
        ? date.from
        : isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = date?.to
        ? date.to
        : isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardQuotationStatusChart(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId
      );
      if (response && response.status) {
        interface ResponseData {
          [key: string]: {
            displayName: string;
            count: number;
          };
        }

        interface Data {
          label: string;
          value: number;
        }

        let responseData: ResponseData = response.data.data;
        let data: Data[] = [];

        for (const key of Object.keys(responseData)) {
          const element = responseData[key];
          data.push({
            label: element.displayName,
            value: element.count,
          });
        }

        setQuotationByStatus(data);
        setTimeout(() => {
          setIsPageLoad(false);
        }, 1000);
      }
    } catch (err) {
      Logger.log(err);
      setIsPageLoad(false);
    }
  };

  const DashboardMapCheckInDetails = async () => {
    try {
      setIsPageLoad(true);
      let fromDate = isCustomDate
        ? customFromDate
        : selectedDateRange.from;
      let toDate = isCustomDate
        ? customToDate
        : selectedDateRange.to;
      const response = await fetchDashboardMapcheckIn(
        fromDate,
        toDate,
        isOrganization,
        selectedUserId,
        selectedTeamId
      );
      if (response && response.status) {
        let resposneData = response.data.data;
        if (resposneData.length > 0) {
          if (Object.values(resposneData[0].extraDetails).length > 0) {
            setMapCheckInData(resposneData);
          } else {
            setMapCheckInData([]);
          }
          setTimeout(() => {
            setIsPageLoad(false);
          }, 1000);
        } else {
          setMapCheckInData([]);
          setIsPageLoad(false);
        }
      }
    } catch (err) {
      setIsPageLoad(false);
      Logger.log(err);
    }
  };

const handleReportSelect = (reportId: string, reportTitle: string) => {
  // Close the selector popup
  setReportSelectorOpen(false);

  // 🚀 NEW ARCHITECTURE: Just store the report info
  // ReportTabsManager is always visible and will handle opening the new tab
  setSelectedReportId(reportId);
  setSelectedReportTitle(reportTitle);
};

// 🚀 NEW: Handle batch filter application from FilterPanel
const handleApplyFilters = (filters: any) => {
  Logger.log('🎯 Applying batched filters:', filters);

  // Update date filter
  const isCustom = filters.dateRange === 'custom';
  setFromDate(filters.dateRange);
  setIsCustomDate(isCustom);

  if (isCustom && filters.customFromDate && filters.customToDate) {
    setCustomFromDate(filters.customFromDate);
    setCustomToDate(filters.customToDate);
    setSelectedDateRange({ from: filters.customFromDate, to: filters.customToDate });
  } else {
    // Clear custom dates when not in custom mode and calculate range
    setCustomFromDate('');
    setCustomToDate('');
    const range = getDateRange(filters.dateRange);
    setSelectedDateRange(range);
    Logger.log('📅 Date range updated:', { filter: filters.dateRange, range });
  }

  // Handle team/org
  if (filters.teamOrOrg === 'organization') {
    setIsOrganization(true);
    setSelectedTeamId('');
    setSelectedUserId('');
  } else if (filters.teamOrOrg) {
    setSelectedTeamId(filters.teamOrOrg);
    setIsOrganization(false);
    setSelectedUserId(filters.teamMember || '');
  } else {
    setSelectedTeamId('');
    setIsOrganization(false);
    setSelectedUserId(filters.teamMember || '');
  }

  // Handle lists
  setSelectedListIds(filters.listIds || []);

  Logger.log('✅ Filters applied successfully:', {
    date: filters.dateRange,
    custom: isCustom ? `${filters.customFromDate} to ${filters.customToDate}` : 'N/A',
    teamOrOrg: filters.teamOrOrg,
    member: filters.teamMember,
    lists: filters.listIds?.length || 0
  });
};

// 🚀 NEW: Clear all filters
const handleClearFilters = () => {
  Logger.log('🧹 Clearing all filters');
  setFromDate('7d');
  setIsCustomDate(false);
  setCustomFromDate('');
  setCustomToDate('');
  setSelectedTeamId('');
  setSelectedUserId('');
  setIsOrganization(false);
  setSelectedListIds([]);
};


const handleTabOnchange = (tab: Tabs) => {
  setTabName(tab);

  // 🚀 NEW ARCHITECTURE: Tabs are just for visual navigation and showing counts
  // All content is now in ReportTabsManager - no tab-specific loading needed

  // Handle reports tab - opens report selector popup
  if (tab === "reports") {
    setReportSelectorOpen(true);
    return;
  }

  // ❌ REMOVED: No longer load tab-specific graph data
  // ❌ REMOVED: No longer show/hide call logs drawer
  // All charts/reports are now accessed via ReportTabsManager
};

  const handleFilteronChange = (date: string) => {
    Logger.log('1. handleFilteronChange called with:', { date });
    
    if (date === 'custom') {
      Logger.log('2. Custom date selected - showing date pickers');
      setFromDate(date);
      setIsCustomDate(true);
      // Don't set range or trigger API calls yet - wait for custom dates to be selected
      return;
    }
    
    const range = getDateRange(date);
    Logger.log('3. Date range calculated:', { date, range });
    
    setSelectedDateRange(range);
    setFromDate(date);
    setIsCustomDate(false);
    
    // Calculate the number of days for the filter
    const daysDiff = moment(range.to).diff(moment(range.from), 'days');
    Logger.log('4. Days difference calculated:', daysDiff);
    
    setFilterFromDate(daysDiff);
  };
  

  
const selectFilterDate = (e: any) => {
  const { name, value } = e.currentTarget;
  Logger.log('🎯 Dashboard.selectFilterDate called with:', { name, value });

  // 🎯 USE DASHBOARD MANAGER - Proper timezone handling
  const dateManager = import('./dashboardManager').then(m => m.DashboardDateManager.getInstance());

  if (name === "from") {
    // Create proper UTC date with startOf day
    const utcDate = moment(value).utc().startOf('day').format();
    setCustomFromDate(utcDate);
    setFromDate('custom');
    setIsCustomDate(true);
    Logger.log('✅ Set custom from date:', utcDate);
  } else {
    // Create proper UTC date with endOf day
    const utcDate = moment(value).utc().endOf('day').format();
    setCustomToDate(utcDate);
    setFromDate('custom');
    setIsCustomDate(true);
    Logger.log('✅ Set custom to date:', utcDate);
  }
};
  const selectFilterUser = (value: string, tab: string) => {
    Logger.log('🎯 selectFilterUser called:', { value, tab });

    // Clear button clicked
    if (!value) {
      if (tab === "team" || tab === "organization") {
        // Clearing team/org selector
        setSelectedTeamId("");
        setIsOrganization(false);
        setSelectedUserId(""); // Also clear team member
      } else if (tab === "Emp") {
        // Clearing team member selector only
        setSelectedUserId("");
      }
      return;
    }

    // Team member selected
    if (tab === "Emp") {
      setSelectedUserId(value);
      Logger.log('✅ Team member selected:', value);
    }
    // Organization selected
    else if (value === "organization") {
      setIsOrganization(true);
      setSelectedTeamId("");  // ❌ Clear team (mutually exclusive)
      setSelectedUserId("");   // ❌ Clear team member
      Logger.log('✅ Organization selected, cleared team & member');
    }
    // Team selected
    else {
      setSelectedTeamId(value);
      setIsOrganization(false);  // ❌ Clear organization flag
      setSelectedUserId("");      // ❌ Clear team member (will reload for new team)
      Logger.log('✅ Team selected, cleared org & member:', value);
    }
  };

  // 🚧 COMMENTED OUT: Handle list selection change from header - Feature under development
  /*
  const handleListSelectionChange = (listIds: string[]) => {
    Logger.log('📋 Dashboard: Received list selection change:', listIds);
    setSelectedListIds(listIds);
  };
  */

  // Logger.log("leadTotals>", leadTotals);
  const secondaryTabsArray: TabItem[] = [
    { 
      key: "contacted", 
      label: "Leads contacted", 
      icon: "fas fa-user-check" 
    },
    { 
      key: "conversion", 
      label: "Lead conversion ratio", 
      icon: "fas fa-exchange-alt" 
    },
    { 
      key: "rate", 
      label: "Task completion rate", 
      icon: "fas fa-tasks" 
    },
    { 
      key: "views", 
      label: "Content views", 
      icon: "fas fa-eye" 
    },
    { 
      key: "shares", 
      label: "Content shares", 
      icon: "fas fa-share-alt" 
    }
  ];
  

  return (
    <div id="main" className="main">
      <Header />
      <section style={{ paddingLeft: 10, paddingTop: 2 }}>
       <DashboardHeader
  fromDate={fromDate}
  handleFilteronChange={handleFilteronChange}
  selectFilterUser={selectFilterUser}
  selectFilterDate={selectFilterDate}
  isCustomDate={isCustomDate}
  customFromDate={customFromDate}
  customToDate={customToDate}
  toDate={currentToDate}
  handleRefresh={handleDashboardRefresh}
  onToggleVisibilitySettings={() => setVisibilitySettingsOpen(true)}
  selectedTeamId={selectedTeamId}
  selectedUserId={selectedUserId}
  isOrganization={isOrganization}
  selectedListIds={selectedListIds} // ✅ Pass selected lists
  onApplyFilters={handleApplyFilters} // 🚀 NEW: Batch filter handler
  onClearFilters={handleClearFilters} // 🚀 NEW: Clear filter handler
/>
        <Spin tip="Loading..." spinning={isPageLoad}>
       <DashboardTabs
  handleTabOnchange={handleTabOnchange}
  selectedTab={tabName}
  totalLeadCount={leadTotals.totalLead}
  totalCallCount={totalCallCount}
  totalActivityCount={totalActivityCount}
  totalSalesCount={totalSalesCount}
  onOpenCallLogs={() => {}} // ❌ REMOVED: No longer opens drawer - all reports in ReportTabsManager
/>
 
          {/*  */}
          

{shouldRenderComponent('metrics', 'secondaryMetrics') && (
<div className="dashboard-section-1">
  <div className="row">
    <ul className="nav nav-pills ml-0 justify-content-start d-flex dashboard_cards" style={{ gap: "8px", marginBottom: "16px", marginTop: "4px" }}>
      {secondaryTabsArray.map((tab: TabItem) => (
        <li
          key={tab.key}
          className="nav-item bg-transparent"
          role="presentation"
          style={{ flex: 1 }}
        >
          <button
            className="nav-link dashboard-section-1-sub-1 bg-white w-100"
            style={{
              background: "white",
              padding: "6px 12px", // Reduced vertical padding
              borderRadius: "4px !important",
              boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
              border: "none",
              height: "40px", // Reduced height
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}
            >
            <div className="d-flex align-items-center gap-2">
              <i className={tab.icon} style={{ color: "#64748b", fontSize: "14px" }} />
              <span style={{ color: "#64748b", fontSize: "14px", whiteSpace: "nowrap" }}>
                {tab.label}
              </span>
            </div>
            <span style={{ fontSize: "16px", fontWeight: "600", color: "#0f172a" }}>
              {tab.key === "views" && contentCountInfo?.view}
              {tab.key === "shares" && contentCountInfo?.share}
              {tab.key === "rate" && `${taskPerc ? Math.round(taskPerc) : 0}%`}
              {tab.key === "contacted" && `${leadTotals?.leadContactedRatio ? Math.round(leadTotals?.leadContactedRatio) : 0}%`}
              {tab.key === "conversion" && `${leadTotals?.leadConversionRatio ? Math.round(leadTotals?.leadConversionRatio) : 0}%`}
            </span>
          </button>
        </li>
      ))}
    </ul>
  </div>
</div>
)}

          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="dashboard-lead"
              role="tabpanel"
              aria-labelledby="Calls-tab"
            ></div>
            <div
              className="tab-pane fade"
              id="dashboard-Calls"
              role="tabpanel"
              aria-labelledby="Calls-tab"
            >
              <div className="dashboard-section-2"></div>
            </div>
            <div
              className="tab-pane fade"
              id="dashboard-Activity"
              role="tabpanel"
              aria-labelledby="Activity-tab"
            ></div>
            <div
              className="tab-pane fade show active"
              id="dashboard-Sales"
              role="tabpanel"
              aria-labelledby="Calls-tab"
            ></div>
          </div>

          {/* Report Selector Popup */}
          <ReportSelectorPopup
            isOpen={reportSelectorOpen}
            onClose={() => setReportSelectorOpen(false)}
            onReportSelect={handleReportSelect}
          />

          {/* 🚀 NEW ARCHITECTURE: Reports Manager Always Visible - All content is now report-based */}
          <ReportTabsManager
            onClose={() => {
              // Note: No longer closing the manager, just used for potential future actions
            }}
            fromDate={selectedDateRange.from}
            toDate={selectedDateRange.to}
            selectedUserId={selectedUserId}
            selectedTeamId={selectedTeamId}
            isOrganization={isOrganization}
            initialReportId={selectedReportId}
            initialReportTitle={selectedReportTitle}
            visibilityConfig={visibilityConfig} // 🚀 Pass visibility config for auto-open
          />
        </Spin>
      </section>

      {/* ❌ LEGACY CODE BLOCK REMOVED - All charts now in ReportTabsManager */}

      {/* Visibility Settings Drawer */}
      <DashboardVisibilitySettings
        open={visibilitySettingsOpen}
        onClose={() => setVisibilitySettingsOpen(false)}
        config={visibilityConfig}
        onConfigChange={(config) => saveConfig(config)}
      />

      {/* Optional: Show enabled components count in a small badge - HIDDEN FOR NOW */}
      {false && !visibilityLoading && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            backgroundColor: '#f0f9ff',
            border: '1px solid #0ea5e9',
            borderRadius: '20px',
            padding: '8px 16px',
            fontSize: '12px',
            color: '#0369a1',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          <span>📊</span>
          {getEnabledCount()}/{getTotalCount()} components enabled
        </div>
      )}

    </div>
  );
};

export default Dashboard;
